import { useContext } from 'react';
import { useApolloClient } from '@apollo/client';
import { AuthorizationContext } from '../../contexts/AuthorizationContext';

export default function useRemoveLifestyleHabitData() {
  const client = useApolloClient();
  const { user } = useContext(AuthorizationContext);

  const remove = async () => {
    await client.refetchQueries({
      updateCache(cache) {
        cache.modify({
          id: cache.identify({ __typename: 'User', id: user?.id }),
          fields: {
            lifestyleHabits(_, details) {
              return details.DELETE;
            },
          },
          optimistic: true,
        });
      },
    });
  };

  return {
    remove,
  };
}
